import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import HeroSlider from '../../components/HeroSlider/HeroSlider'
import ProductSlider from '../../components/ProductSlider/ProductSlider'
import Brands from '../../components/Brands/Brands'
import TopCategories from '../../components/TopCategories/TopCategories'
import TrustSection from '../../components/TrustSection/TrustSection'
import WellnessSpaces from '../../components/WellnessSpaces/WellnessSpaces'
import { getActiveSliders } from "../../actions/sliderActions";
import { getActiveMainCategories, getActiveCategories } from "../../actions/categoryActions";
import { getActiveBrands } from '../../actions/brandActions';
import { fetchMeta } from '../../actions/metaActions';
import { getActiveTrendingHighlights, getActiveNewHighlights, getActiveOfferHighlights } from "../../actions/productActions";

const Home = () => {

    const dispatch = useDispatch();
    const { categories = [], mainCategories, loading: categoriesLoading, error: categoriesError } = useSelector(state => state.categoriesState);
    const { sliders = [], loading: slidersLoading, error: sliderError } = useSelector(state => state.slidersState);
    const { trendingProducts, newProducts, offerProducts, error: highlightError, loading: highlightLoading } = useSelector(state => state.productsState);
    const { brands = [], loading = true, error: brandsError } = useSelector(state => state.brandsState);
    const { meta, loading: metaLoading } = useSelector((state) => state.metaState);

    useEffect(() => {
        dispatch(fetchMeta('home'));
        dispatch(getActiveSliders());
        dispatch(getActiveMainCategories());
        dispatch(getActiveBrands());
        dispatch(getActiveCategories());
        dispatch(getActiveTrendingHighlights('trending'));
        dispatch(getActiveNewHighlights('new'));
        dispatch(getActiveOfferHighlights('deal'));
    }, [dispatch]);

    return (
        <div className='bg-g'>
            <Helmet>
                <title>{meta?.title || 'SPA Brands | Premium Beauty & Wellness Products'}</title>
                <meta name="description" content={meta?.metaDescription || 'Shop premium beauty, skincare & wellness products online in UAE.'} />
                <meta name="keywords" content={meta?.keywords} />
                <link rel="canonical" href={meta?.canonicalUrl || 'https://spabrands.me/'} />
                <meta name="robots" content={meta?.robots || "index, follow"} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Brand",
                        "name": "SPA Brands",
                        "url": "https://spabrands.me/",
                        "logo": "https://spabrands.me/logo.png",
                        "description": "SPA Brands is an online store offering premium spa, beauty, skincare, haircare and wellness products.",
                        "sameAs": [
                            "https://www.instagram.com/spabrands.me",
                            "https://www.facebook.com/spabrands.me"
                        ]
                    })}
                </script>

            </Helmet>
            <section >
                <HeroSlider slides={sliders} />
            </section>
            <section className='pb-5' >
                <TrustSection />
            </section>
            <div className='custom-container'>
                <section className='pb-5'>
                    <TopCategories title='Top Categories' categories={mainCategories} />
                </section>
                <section className='pb-5' >
                    <ProductSlider title='New Arrivals' products={newProducts} />
                </section>
                <section className='pb-5' >
                    <Brands brands={brands} />
                </section >
                <section className='pb-5'>
                    <ProductSlider title='Trending Products' products={trendingProducts} />
                </section>
                <section className='pb-5' >
                    <WellnessSpaces categories={categories} />
                </section>
                <section className='pb-5' >
                    <ProductSlider title='Latest Deals' products={offerProducts} />
                </section>
                {/* <Testimonials /> */}
            </div>
        </div>
    )
}

export default Home